<template>
    <div :data-component="$options.name">
        <div
            class="flex justify-between items-center h-52 py-5 px-[12px] text-text-l-desktop border border-solid rounded-normal"
            :class="[
                hasError
                    ? 'border-color-alert-negative-100'
                    : isDisabled
                      ? 'border-color-neutral-grey-10'
                      : 'border-color-neutral-grey-20',
            ]"
        >
            <span
                class="mr-8 text-ellipsis overflow-hidden whitespace-nowrap"
                :class="{ 'text-color-neutral-grey-10': isDisabled, 'text-color-alert-negative-100': hasError }"
                >{{ label }}</span
            >
            <div class="flex items-center">
                <cs-secondary-button
                    class="mr-16"
                    :ariaLabel="`Zähler um ${interval} verringern`"
                    :isSmall="true"
                    :isDisabled="isDisabled"
                    @click="decrementCounter"
                >
                    <template #icon><ms-minus /></template>
                </cs-secondary-button>
                <span
                    class="flex justify-center w-24"
                    :class="{ 'text-color-neutral-grey-10': isDisabled }"
                    >{{ fieldValue }}</span
                >
                <cs-secondary-button
                    class="ml-16"
                    :ariaLabel="`Zähler um ${interval} erhöhen`"
                    :isSmall="true"
                    :isDisabled="isDisabled"
                    @click="incrementCounter"
                >
                    <template #icon><ms-plus /></template>
                </cs-secondary-button>
            </div>
            <input
                type="hidden"
                :value="fieldValue"
            />
        </div>
        <div
            v-if="hasError && errorMsg"
            class="mt-8 text-caption text-color-alert-negative-100"
            data-cy="errorMsg"
        >
            {{ errorMsg }}
        </div>
    </div>
</template>
<script lang="ts" src="./CsInputCounter.ts" />
